<template>
  <div class="manegelist">
    <Header></Header>
    <Title title="试卷管理"></Title>
    <div class="contain_main">
      <div class="search" @keydown.enter="changepage(1)">
        <div class="search_item">
          <div class="item">
            <span>试卷名称:</span>
            <Input v-model="data.eptitle" placeholder="请输入..." style="width:2rem"/>
          </div>
          <!-- <div class="item">
            <span>考试状态:</span>
            <Select v-model="model1" style="width:1rem">
              <Option value="1">全部</Option>
              <Option value="2">进行中</Option>
              <Option value="3">已结束</Option>
            </Select>
          </div>-->
          <div class="item">
            <div class="button" @click="changepage(1)">搜索</div>
          </div>
          <div class="item" style="margin-left:1rem">
            <div class="button" @click="model=true">创建试卷</div>
          </div>
        </div>
      </div>
      <div class="table">
        <table>
          <thead>
            <tr>
              <td>试卷编号</td>
              <td>试卷名称</td>
              <td>试卷类型</td>
              <td>题目数</td>
              <td>考试总分</td>
              <!-- <td>创建时间</td> -->
              <td>最后编辑时间</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in list" :key="'list'+index">
              <td>{{item.epid}}</td>
              <td>
                <Tooltip :content="item.eptitle" placement="top-start">
                  <span class="tableName">{{item.eptitle}}</span>
                </Tooltip>
              </td>
              <td>{{item.eptype|typed}}</td>
              <td>{{item.epcount}}</td>
              <td>{{item.epscore}}</td>
              <!-- <td>{{item.epcreatetime|formatetime}}</td> -->
              <td>{{(item.epupdatetime?item.epupdatetime:item.epcreatetime)|formatetime}}</td>
              <td>
                <button class="green" @click="scan(item.eptype,item.epid)">预览</button>
                <button class="blue" @click="edit(item.eptype,item.epid)">编辑</button>
                <button class="orange" @click="copy(item.eptype,item.epid)">复制</button>
                <button class="red" @click="del(item.epid)">删除</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class style="text-align:right;margin-top:20px;">
        <Page
          :total="total"
          :current="data.page"
          :page-size ='data.size'
          @on-change="changepage"
          @on-page-size-change="changesize"
          show-sizer
          show-elevator
          show-total
          :page-size-opts="[5,10, 20,50]"
        />
      </div>
    </div>
    <div style="height:100px"></div>
    <toast @close="close" v-if="model"></toast>
  </div>
</template>
<script>
import Header from "../../components/header";
import Title from "../../components/title";
import toast from "../../components/toast/creatpapertype";
import {
  ExamPaper_indexp,
  ExamPaper_del,
  ExamPaper_copy
} from "../../assets/js/api.js";
export default {
  name: "manegelist",
  data() {
    return {
      list: [],
      model: false,
      total: null,
      data: {
        eptitle: "", //	string	true	普通参数		标题
        page: 1, //	string	true	普通参数		页码
        size: 10 //	string	true	普通参数		数量
      }
    };
  },
  mounted() {
    if (this.$route.query.page && this.$route.query.size) {
      this.data.page = this.$route.query.page - 0;
      this.data.size = this.$route.query.size - 0;
    }
    this.getlist();
  },
  filters: {
    // 1普通试卷2抽题试卷3随机试卷
    typed(value) {
      switch (value) {
        case 1:
          return "普通试卷";
        case 2:
          return "抽题试卷";
        case 3:
          return "随机试卷";
      }
    }
  },
  components: {
    Header,
    Title,
    toast
  },
  methods: {
    close() {
      this.model = false;
    },
    changepage(data) {
      this.data.page = data;
      this.$router.push({
        path: "/manage/publiclist",
        query: {
          page: this.data.page,
          size: this.data.size
        }
      });
      this.getlist();
    },
    changesize(data) {
      this.data.page = 1;
      this.data.size = data;
      this.$router.push({
        path: "/manage/publiclist",
        query: {
          page: this.data.page,
          size: this.data.size
        }
      });
      this.getlist();
    },
    getlist() {
      ExamPaper_indexp(this.data).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.list;
          this.total = res.data.data.count;
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    del(data) {
      if (!confirm("您确定要删除该条信息？")) {
        return;
      }
      ExamPaper_del({ epid: data }).then(res => {
        if (res.data.code == 200) {
          this.$Notice.success({ title: "成功提示", desc: "删除成功！" });
          this.getlist();
          return;
        }
        this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      });
    },
    edit(data, id) {
      if (data == 1) {
        this.$router.push({
          path: "/manage/normalpaper",
          query: { editid: id }
        });
        return;
      }
      if (data == 2) {
        this.$router.push({
          path: "/manage/selectpaper",
          query: { editid: id }
        });
        return;
      }
      if (data == 3) {
        this.$router.push({
          path: "/manage/radompaper",
          query: { editid: id }
        });
        return;
      }
    },
    scan(type, id) {
      this.$router.push({
        path: "/scanexam",
        query: {
          id: id,
          type: type
        }
      });
    },
    copy(data, id) {
      // ExamPaper_copy({ id: data }).then(res => {
      //   if (res.data.code == 200) {
      //     this.$Notice.success({ title: '成功提示',desc:'复制成功！'});;
      //     this.getlist();
      //     return;
      //   }
      //   this.$Notice.warning({ title: "信息提示", desc: res.data.message });
      // });
      if (data == 1) {
        this.$router.push({
          path: "/manage/normalpaper",
          query: { copyid: id }
        });
        return;
      }
      if (data == 2) {
        this.$router.push({
          path: "/manage/selectpaper",
          query: { copyid: id }
        });
        return;
      }
      if (data == 3) {
        this.$router.push({
          path: "/manage/radompaper",
          query: { copyid: id }
        });
        return;
      }
    }
  }
};
</script>
<style lang="css" scoped>
/* 搜索栏样式------------------------------------------------------------------------------------------- */
.search {
  margin-top: 0.2rem;
  display: flex;
  color: #575e6b;
}
.search .search_item {
  display: flex;
}
.search .search_item .item {
  margin: 0 0.15rem;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
}
/* 表格栏目样式----------------------------------------------------------------------------------------------*/
.table {
  margin-top: 0.6rem;
  font-size: 0.14rem;
}
table {
  width: 100%;
}
thead tr {
  color: #a4acbf;
}
tbody tr {
  color: #707788;
}
tr {
  height: 0.6rem;
}
/*查看详情button-----------------------------------------------------------------------------------------------------------------*/
button {
  border-radius: 0.2rem;
  border: none;
  margin: 0 0.02rem;
  padding: 0.04rem 0.1rem;
  font-size: 0.14rem;
  outline: none;
}
button.blue {
  color: #25b3f9;
  background: #d3f3fc;
}
button.pri {
  color: #e037ff;
  background: #fadfff;
}
button.orange {
  color: #ff8d13;
  background: #ffe2c4;
}
button.green {
  color: #36cd68;
  background: #cffade;
}
button.red {
  color: #ff3a68;
  background: #ffd6de;
}
</style>


// WEBPACK FOOTER //
// src/pages/namnege/publiclist.vue